import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends withBreakpointObserver(Base) {
  open = false;

  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['close', 'submenu'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Click on Item with submenu
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onClick({ event }) {
    if (!this.open) {
      event.preventDefault();
      this.openSubmenu();
    }
  }

  /**
   * Close menu item
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onCloseClick({ event }) {
    event.stopPropagation();
    this.closeSubmenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openSubmenu() {
    if (this.open) return;

    this.$parent.submenuOpen = true;

    this.$refs.submenu.classList.remove('max-l:translate-x-full');
    this.open = true;
  }

  /**
   * Close menu nothing more
   * @returns {void}
   */
  closeSubmenu() {
    this.$refs.submenu.classList.add('max-l:translate-x-full');
    this.open = false;
    this.$parent.submenuOpen = false;
  }
}
